import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/modules/profiles/assets/icons/icon-red-trash.svg'


const _withScopeId = n => (_pushScopeId("data-v-2363029a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "selectors" }, null, -1))
const _hoisted_2 = { class: "options" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Enabled ")
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Disabled ")
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enable && _ctx.enable(...args))),
          class: "toggle"
        }, [
          _hoisted_3,
          _createElementVNode("img", {
            src: _ctx.profileStatus === "enabled" ? _ctx.selectedDot : _ctx.unselectedDot,
            alt: "enable",
            class: "dot"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.disable && _ctx.disable(...args))),
          class: "toggle"
        }, [
          _hoisted_5,
          _createElementVNode("img", {
            src: _ctx.profileStatus === "disabled" ? _ctx.selectedDot : _ctx.unselectedDot,
            alt: "disable",
            class: "dot"
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("img", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteProfile && _ctx.deleteProfile(...args))),
          src: _imports_0,
          alt: "trash",
          class: "delete"
        })
      ])
    ])
  ]))
}